import { render } from "./Email-Frame-Selector.vue?vue&type=template&id=276621ca&scoped=true"
import script from "./Email-Frame-Selector.vue?vue&type=script&lang=js"
export * from "./Email-Frame-Selector.vue?vue&type=script&lang=js"

import "./emailFrameSelectorStyle.scss?vue&type=style&index=0&id=276621ca&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276621ca"]])

export default __exports__